import { render, staticRenderFns } from "./NumberCodeInput.vue?vue&type=template&id=0fca3c9a&scoped=true"
import script from "./NumberCodeInput.vue?vue&type=script&lang=ts"
export * from "./NumberCodeInput.vue?vue&type=script&lang=ts"
import style0 from "./NumberCodeInput.vue?vue&type=style&index=0&id=0fca3c9a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fca3c9a",
  null
  
)

export default component.exports